import './ComoFunciona.css';
import imagem from "./img/ComoFunciona.png";

function ComoFunciona() {
  return (
    <div id="ComoFunciona" className="ComoFuncionaContainer">
        <div className="ComoFuncionaLeft">
            <div className="ComoFuncionaTop">
                Como funciona a Sofie
            </div>
            <div className="ComoFuncionaBottom">
                A Sofie é uma startup que busca inovar a forma de gerar renda extra para seus usuários de uma forma simples e rápida.
            </div>
            <div className="ComoFuncionaBottom">
                Em pouco tempo, você verá sua carteira crescer com dinheiro vindo da Sofie. É só resgatar e ser feliz!
            </div>
        </div>
        <div className="ComoFuncionaRight">
            <img width="100%" src={imagem} alt="Como Funciona" />
        </div>
    </div>
  );
}

export default ComoFunciona;
